module.exports = __webpack_public_path__ + "static/media/save-dark.59a8780f.svg";